const state = {
  showGiftDialog: false,
  pickGiftItem: '',
};

const mutations = {
  SHOW_GIFT_DIALOG(state, flag) {
    state.showGiftDialog = flag;
  },
  SET_GIFT_ITEM(state, data) {
    state.pickGiftItem = { ...data };
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
